"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SalesforceEventSetting = void 0;

var SalesforceEventSetting =
/** @class */
function () {
  function SalesforceEventSetting(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - salesforceEventSettingId
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.GetSalesforceEventSetting = function (salesforceEventSettingId) {
    return this.restClient.get('SalesforceEventSetting/UseCase/GetSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId
    });
  };
  /**
   * @param string - eventId
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.ListSalesforceEventSettingsForEvent = function (eventId) {
    return this.restClient.get('SalesforceEventSetting/UseCase/ListSalesforceEventSettingsForEvent', {
      eventId: eventId
    });
  }; // Commands

  /**
   * @param string - salesforceEventSettingId
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.DisableExportForSalesforceEventSetting = function (salesforceEventSettingId) {
    return this.restClient.post('SalesforceEventSetting/UseCase/DisableExportForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.DisableImportForSalesforceEventSetting = function (salesforceEventSettingId) {
    return this.restClient.post('SalesforceEventSetting/UseCase/DisableImportForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.EnableExportForSalesforceEventSetting = function (salesforceEventSettingId) {
    return this.restClient.post('SalesforceEventSetting/UseCase/EnableExportForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.EnableImportForSalesforceEventSetting = function (salesforceEventSettingId) {
    return this.restClient.post('SalesforceEventSetting/UseCase/EnableImportForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @param string - campaignId
   * @param string - campaignName
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.SetCampaignForSalesforceEventSetting = function (salesforceEventSettingId, campaignId, campaignName) {
    return this.restClient.post('SalesforceEventSetting/UseCase/SetCampaignForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId,
      campaignId: campaignId,
      campaignName: campaignName
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @param number - invitationCount 1-100
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.SetInvitationCountForSalesforceEventSetting = function (salesforceEventSettingId, invitationCount) {
    return this.restClient.post('SalesforceEventSetting/UseCase/SetInvitationCountForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId,
      invitationCount: invitationCount
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @param string - invitationCreationType unconfirmed-no-email|confirmed-no-email
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.SetInvitationCreationTypeForSalesforceEventSetting = function (salesforceEventSettingId, invitationCreationType) {
    return this.restClient.post('SalesforceEventSetting/UseCase/SetInvitationCreationTypeForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId,
      invitationCreationType: invitationCreationType
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @param string - newContactRule do-nothing|create-contact|create-lead
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.SetNewContactRuleForSalesforceEventSetting = function (salesforceEventSettingId, newContactRule) {
    return this.restClient.post('SalesforceEventSetting/UseCase/SetNewContactRuleForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId,
      newContactRule: newContactRule
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @param string - stackId
   * @return Promise|Observable|any
   */


  SalesforceEventSetting.prototype.SetStackForSalesforceEventSetting = function (salesforceEventSettingId, stackId) {
    return this.restClient.post('SalesforceEventSetting/UseCase/SetStackForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId,
      stackId: stackId
    });
  };

  return SalesforceEventSetting;
}();

exports.SalesforceEventSetting = SalesforceEventSetting;